import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  label: string;
  onClick?: () => void;
};

export function AIActionCard({ label, onClick }: Props) {
  return (
    <Box
      px="xl"
      py="md"
      onClick={onClick}
      style={{
        background: 'rgba(0, 0, 0, 0.25)',
        borderRadius: 'var(--mantine-radius-xl)',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <Text size="textXl" fw={FONT_WEIGHTS.bold} c="white">
        {label}
      </Text>
    </Box>
  );
}
